import {styled} from "@mui/material/styles";
import {COLOR_BLACK, COLOR_BLUE, COLOR_BLUE_SECONDARY, COLOR_DARK_GREY, COLOR_GREY} from "@/themes/colors.jsx";

export const Flex = styled('div')({
    display: 'flex',
});

export const Mt3 = styled('div')({
    marginTop: '1rem',
});

export const Mt4 = styled('div')({
    marginTop: '1.5rem',
});

export const Title = styled('div')({
    fontSize: '21px',
    lineHeight: '31px',
    fontWeight: 700,
});

export const Text = styled('div')({
    fontSize: '19px',
    lineHeight: '22.67px',
    fontWeight: 500,
});

export const ContainerBoxHeader = styled('div')({
    paddingBottom: '1.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    // alignItems: 'center',
});

export const ContainerBoxTitle = styled('div')({
    fontSize: '19px',
    lineHeight: '29px',
    fontWeight: 800,

    '@media (max-width: 767.98px)': {
        fontSize: '17px',
        lineHeight: '26px',
    }
});

export const ContainerBoxHeaderRight = styled('div')({

});

export const ContainerBoxNote = styled('div')({
    marginTop: '1.5rem',
    fontSize: '11px',
    lineHeight: '13px',
    fontWeight: 600,
    color: COLOR_GREY,
});

export const ContainerBoxSkipLink = styled('div')({
    fontSize: '17px',
    lineHeight: '20.29px',
    fontWeight: 600,
    color: COLOR_BLACK + '4d',
    cursor: 'pointer',

    '&:hover': {
        color: COLOR_GREY,
    }
});

export const ContainerBoxSaveLink = styled('div')({
    fontSize: '17px',
    lineHeight: '20.29px',
    fontWeight: 600,
    color: COLOR_BLUE,
    cursor: 'pointer',

    '&:hover': {
        color: COLOR_BLUE_SECONDARY,
    }
});

export const ContainerBoxLink = styled('div')({
    fontSize: '17px',
    lineHeight: '20.29px',
    fontWeight: 800,
    color: COLOR_BLUE,
    cursor: 'pointer',
    paddingLeft: '22px',

    '&:hover': {
        color: COLOR_BLUE_SECONDARY,
    }
});
